import * as React from 'react';

import './animations.css';

export const LoaderLine = () => {
  return (
    <div className='bg-primary/25 relative block h-1 w-full overflow-hidden'>
      <div className='loader-line-bar bg-primary' />
    </div>
  );
};
